"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalLayoutRenderer = exports.VERTICAL_LAYOUT_FORM_TEST_ID = void 0;
exports.VerticalLayout = VerticalLayout;
const jsx_runtime_1 = require("react/jsx-runtime");
const LayoutRenderer_1 = require("./LayoutRenderer");
const antd_1 = require("antd");
const react_1 = require("@jsonforms/react");
exports.VERTICAL_LAYOUT_FORM_TEST_ID = "vertical-layout-form";
function VerticalLayout({ uischema, schema, path, enabled, visible, renderers, cells, }) {
    const { elements } = uischema;
    const childProps = {
        elements,
        schema,
        path,
        enabled,
        visible,
    };
    const form = antd_1.Form.useFormInstance();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form, { "data-testid": exports.VERTICAL_LAYOUT_FORM_TEST_ID, component: form ? false : "form", scrollToFirstError: true, form: form, children: (0, jsx_runtime_1.jsx)(LayoutRenderer_1.AntDLayout, { ...childProps, renderers: renderers, cells: cells }) }));
}
exports.VerticalLayoutRenderer = (0, react_1.withJsonFormsLayoutProps)(VerticalLayout);
